module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('h2', {
    staticClass: "text-size-13 text-uppercase text-regular text-center mb20"
  }, [_vm._v("Action required")]), _vm._v(" "), _c('p', {
    staticClass: "text-size-18 text-medium text-center mb20"
  }, [_vm._v("Do you want to add " + _vm._s(_vm.args.designer.name) + " " + _vm._s(_vm.args.designer.surname) + " to"), _c('br'), _vm._v("\n   " + _vm._s(_vm.args.projectName) + " as a designer ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Confirm")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faa2ef82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/task/modals/TaskAssigneeDesignerModal.vue
// module id = 455
// module chunks = 2